import React, { useEffect, useState } from 'react';

import { addClass, removeClass } from '~/common';
import { useIsGreaterThanMobile } from '~/src/common/mediaQueries';

import { HIDDEN_ELEMENT_CLASS_NAME, VOLUME_BUTTON_CLASS_NAME } from '../brightcove-constants';
import { useMediaPlayer } from '../MediaPlayerProvider';

function useAdjustInitialVolume() {
  const { player } = useMediaPlayer();
  const isGreaterThanMobile = useIsGreaterThanMobile();
  const [isVolumeInitialized, setIsVolumeInitialized] = useState(false);

  useEffect(() => {
    if (player !== null && !isVolumeInitialized) {
      /**
       * on mobile the user will manage the volume with buttons,
       * so we need to be sure that player volume is 100%.
       * NOTE: we need to do this only once, so the browser resizes will not affect volume
       */
      if (!isGreaterThanMobile) {
        player.volume(1);
        player.muted(false);
      }
      setIsVolumeInitialized(true);
    }
  }, [player, isGreaterThanMobile, isVolumeInitialized]);
}

function showButton(btn: Element | null) {
  if (btn !== null) {
    removeClass(btn, HIDDEN_ELEMENT_CLASS_NAME);
  }
}

function hideButton(btn: Element | null) {
  if (btn !== null) {
    addClass(btn, HIDDEN_ELEMENT_CLASS_NAME);
  }
}

function useHideVolumeBtnOnMobile() {
  const { player } = useMediaPlayer();
  const isGreaterThanMobile = useIsGreaterThanMobile();

  useEffect(() => {
    if (player !== null) {
      const volumeButton = player.$(`.${VOLUME_BUTTON_CLASS_NAME}`);
      if (isGreaterThanMobile) {
        showButton(volumeButton);
      } else {
        hideButton(volumeButton);
      }
    }
  }, [player, isGreaterThanMobile]);
}

export const HideVolumeButtonOnMobile: React.FC = () => {
  useAdjustInitialVolume();
  useHideVolumeBtnOnMobile();
  return null;
};
